<template>
  <Teleport to="body">
    <div
      v-if="visibleStatus !== null"
      :class="[
        'collab-status-banner alert mb-0 rounded-0 text-center py-2',
        visibleStatus === 'authError' ? 'alert-danger' : 'alert-warning',
      ]"
      role="alert"
      aria-live="assertive"
    >
      <strong v-if="visibleStatus === 'authError'">
        Your changes can't be saved. Please refresh the page to sign in again.
      </strong>
      <strong v-else>
        We're having trouble saving your changes. They'll be saved when the
        connection is restored — please don't close this tab.
      </strong>
    </div>
  </Teleport>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import store, { CollabStatus } from '@app/store';

export default defineComponent({
  computed: {
    visibleStatus(): Exclude<CollabStatus, 'connected'> | null {
      // Only surface a banner when at least one editor has actual unsynced
      // local changes at risk; a dropped connection on an untouched field is
      // not a save failure for the user.
      const atRisk = Object.values(store.state.collabConnections)
        .filter((entry) => entry.hasUnsyncedChanges);
      if (atRisk.some((entry) => entry.status === 'authError')) {
        return 'authError';
      }
      if (atRisk.some((entry) => entry.status === 'reconnecting')) {
        return 'reconnecting';
      }
      return null;
    },
  },
});
</script>

<style scoped>
.collab-status-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1080;
}
</style>
